/* eslint-disable no-useless-escape */
import { Box } from "@mui/material";
import React, { useState, useEffect } from "react";
import styles from "./addDealerForm.module.scss";
import MultistepForm, {
  FormStep,
} from "../../../../components/mutiStepForm/MultistepForm";
import * as Yup from "yup";

import DealerCommunicationSection from "./DealerCommunicationSection";
import DealerDetailsFormSection from "./DealerDetailsFormSection";
import {
  dropdownValueYesNo,
  generalValidationMessage,
  getDropDownValue,
  NewAssignCertificates,
} from "../../../../config/appConfig";
import i18next from "i18next";
import {
  getDealerDetails,
  postDealerDetails,
  getProvinceList,
} from "../../../../services/APIService";
import { useApiErrorModalContext } from "../../../../errorHandling/ApiErrorModalContext";
import _ from "lodash";
import PropTypes from "prop-types";

const AddDealerForm = (props) => {
  const { setShowMessage, onCancel, dealerNo = 0, refreshTable, exactSubcriptionList=[] } = props;
  const translatedGeneralValidationMessage = `${i18next.t(
    generalValidationMessage
  )}`;
  const defaultInitialValue = {
    dealer_Id: dealerNo,
    exact_Number: null,
    exact_number_manual: null,
    provider_Number: "",
    bovag_Number: "",
    province: {key: "Onbekend", value: 13},
    dealer_Status: null,
    software_System: {key: "Onbekend", value: 1},
    kvK_Number: "",
    kvK_Vestigings_Number: "",
    source_System_Id: { key: "Manual", value: 10 },
    dealer_Name: "",
    comments: "",
    Assign_Certificates: [],
    combine_Certificate: getDropDownValue(false, dropdownValueYesNo),
    email_Id: "",
    certificate_Email_Id: "",
    contact_Number: "",
    postcode: "",
    house_Number: "",
    additional_House_Number: "",
    street: "",
    city: "",
  };
  const [dealerDetails, setDealerDetails] = useState(defaultInitialValue);
  const { setApiErrorModalState } = useApiErrorModalContext();
  const [provinceList, setProvinceList] = useState([]);
  const getCertificates = (value) => {
    let certificates = [];
            value.map((item) => {
              let selectedOption = [NewAssignCertificates.find((option) => option.id === item.id)];
              return certificates.push(selectedOption[0]);
            });
    return certificates

  }
  
  useEffect(() => {
    if (dealerNo === 0) {
      setDealerDetails(defaultInitialValue);
    } else {
      getDealerDetails({ dealerId: dealerNo })
        .then((response) => {
          if (!_.isEmpty(_.get(response, "errorMessage", ""))) {
            _.set(response, "status", 200);

            setApiErrorModalState({ error: response });
          } else if (_.get(response, "success", true) === false) {
            _.set(response, "status", 200);
            setApiErrorModalState({
              error: response,
            });
          } else {            
            
            let updatedResponse = {
              ...response,
              ...{
                source_System_Id:_.get(response, "keyValuePairSource", null),
                software_System: _.get(
                  response,
                  "keyValuePairSoftwareSystem",
                  null
                ),

                combine_Certificate: getDropDownValue(
                  _.get(response, "combine_Certificate", false),
                  dropdownValueYesNo
                ),
                dealer_Status: _.get(response, "keyValuePairStatus", null),
                Assign_Certificates: getCertificates(_.get(response, "certificates", [])),
                province: _.get(response, "keyValuePairProvince", null),
                 //update 2mrw
                exact_Number: _.isNull(_.get(response, "exact_Number", null)) ?
                null :                 
                {key:_.get(response, "dealer_Name", null),value:_.get(response, "exact_Number", null)},
                exact_number_manual: _.get(response, "exact_Number", null)              
                
              },
            };
            // removing to avoid edit issue
            let keysTobeRemoved = Object.keys(updatedResponse).filter((key) =>
              key.includes("status_")
            );
            keysTobeRemoved.forEach((attri) => delete updatedResponse[attri]);
            setDealerDetails(updatedResponse);
          }
        })
        .catch((err) => {
          setApiErrorModalState({ error: err });
        });
    }
    getProvinceList()
      .then((response) => {
        if (!_.isEmpty(_.get(response, "errorMessage", ""))) {
          _.set(response, "province", 200);

          setApiErrorModalState({ error: response });
        } else if (_.get(response, "success", true) === false) {
          _.set(response, "province", 200);
          setApiErrorModalState({ error: _.get(response, "message", "true") });
        } else {
          setProvinceList(response);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const validationDetailsSection = Yup.object({
    /*  isJa: Yup.bool(false),
    Assign_Certificates: Yup.array()
      .typeError(translatedGeneralValidationMessage)
      .when("dealer_Status", {
        is: () => document.getElementById("dealer_Status")?.value === "Ja",
        then: () =>
          Yup.array()
            .required(translatedGeneralValidationMessage)
            .min(1, translatedGeneralValidationMessage),
        otherwise: () => Yup.array().notRequired(),
      }), */
    /* exact_Number: Yup.string()
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage), */
    dealer_Name: Yup.string()
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage),
    // exact_number_manual: Yup.string()
    //   .typeError(translatedGeneralValidationMessage)
    //   .required(translatedGeneralValidationMessage),
    /* provider_Number: Yup.string()
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage),
    bovag_Number: Yup.string()
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage),

    province: Yup.string()
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage), 
    
    software_System: Yup.object()
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage),
      */

    dealer_Status: Yup.object()
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage),

    combine_Certificate: Yup.object()
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage),

    source_System_Id: Yup.object()
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage),
  });

  const validationCommunicationSection = Yup.object({
    email_Id: Yup.string()
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage)
      .email(translatedGeneralValidationMessage),

    certificate_Email_Id: Yup.string()
      .typeError(translatedGeneralValidationMessage)
      .email(translatedGeneralValidationMessage)
      .nonNullable(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage),

    contact_Number: Yup.string()

      .matches(/^[0-9\-() ]+$/, translatedGeneralValidationMessage)
      .max(17, translatedGeneralValidationMessage)
      .typeError(translatedGeneralValidationMessage),
    //.required(translatedGeneralValidationMessage),

    postcode: Yup.string()
      .matches(/^\d{4}[A-Z]{2}$/, translatedGeneralValidationMessage)
      .min(6, translatedGeneralValidationMessage)
      .max(6, translatedGeneralValidationMessage)
      .typeError(translatedGeneralValidationMessage),
    //.required(translatedGeneralValidationMessage),

    /* house_Number: Yup.string()
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage),

    street: Yup.string()
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage),

    city: Yup.string()
      .typeError(translatedGeneralValidationMessage)
      .required(translatedGeneralValidationMessage), */
  });

  const onDealerSubmit = (values) => {
    let Province_Id = values.province?.value; //getProvinceId(values.province);
    let Assign_certificate = [];

    let dealerStatus = _.get(values, "dealer_Status", "");

    if (dealerStatus?.key === "Ja") {
      Assign_certificate = _.get(values, "Assign_Certificates", []);
    }    
    values = {
      ...values,
      ...{
        province_Id: Province_Id,
        Assign_Certificates: Assign_certificate
      },
    };

    postDealerDetails(values)
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          refreshTable();

          setShowMessage(true);
          onCancel();
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
  };

  return (
    <Box
      className={styles.addDealerFormWrapper}
      id="addDealerFormWrapper"
      data-testid="add-dealer-form"
    >
      <MultistepForm
        defaultValue={dealerDetails}
        onSubmit={(values) => {
          onDealerSubmit(values);
        }}
        onCancel={onCancel}
      >
        <FormStep
          stepName="1.Details"
          onSumbit={() => console.log("Step1 submit")}
          validationSchema={validationDetailsSection}
        >
          <DealerDetailsFormSection exactSubcriptionList={exactSubcriptionList} provinceList={provinceList}/>
        </FormStep>
        <FormStep
          stepName={i18next.t("2.Communication details")}
          onSumbit={() => console.log("Step2 submit")}
          validationSchema={validationCommunicationSection}
        >
          <DealerCommunicationSection />
        </FormStep>
      </MultistepForm>
    </Box>
  );
};
export default AddDealerForm;
AddDealerForm.propTypes = {
  setShowMessage: PropTypes.any,
  onCancel: PropTypes.func,
  dealerNo: PropTypes.any,
  refreshTable: PropTypes.any,
  exactSubcriptionList: PropTypes.any,
};
